import { type Action } from '~/components/Actions'
import Icon from '~/components/Icon.tsx'
import { Button } from '~/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~/components/ui/dropdown-menu'
import { Text } from '~/components/ui/text'
import { cn } from '~/lib/utils.ts'

export function ContextActionsMenu({
  className,
  actions,
}: {
  className?: string
  actions: Action[]
}) {
  return (
    <DropdownMenu className="relative z-50">
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className={cn('hover:bg-muted active:bg-muted', className)}>
          <Icon name="more-vertical" library="feather" size={20} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        alignOffset={10}
        sideOffset={5}
        className="min-w-56 rounded-xl p-1.5"
        align="end">
        {actions.map((action) => (
          <DropdownMenuItem key={action.key} onPress={action.onPress} disabled={action.disabled}>
            {action.icon && (
              <Icon
                name={action.icon}
                size={16}
                className={cn('text-foreground', action.iconClassName)}
                color={action.iconColor}
              />
            )}
            <Text className={action.labelClassName}>{action.label}</Text>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
